module.exports = __webpack_public_path__ + "static/media/iconAgendaActive.bc6ac360.svg";